import { useState } from "react";

import OurPriceContent from "./OurPriceContent.json";

import { useDispatch, useSelector } from 'react-redux';
import {
  addServiceToCart,
  removeServiceFromCart,
  increaseQuantity,
  decreaseQuantity,
} from '../../redux/cartSlice';
import OurPriceServiceCard from "./OurPriceServiceCard";


const OurPrice = () => {
  const [type, setType] = useState("Split");

  const [view, setView] = useState(null);

  const OurPriceData = OurPriceContent;


  

  
  return (
    <div>
      <div className="our-price" id="price-list">
        <div className="our-price-main">
          <div className="our-price-label">RepairBuddy Price & Features</div>
          <div className="our-price-heading">Our Global Standard Price</div>
          <div className="our-price-content">
            <div className="our-price-features">
              <div className="our-price-features-heading">
                Regular AC Maintenance Helps To
              </div>
              <div className="our-price-features-list">
                <div>
                  <i class="fa-solid fa-circle-check"></i>Improve Cooling
                </div>
                <div>
                  <i class="fa-solid fa-circle-check"></i>Reduce Electricity
                  Bills
                </div>
                <div>
                  <i class="fa-solid fa-circle-check"></i>Increase AC's Lifespan
                </div>
                <div>
                  <i class="fa-solid fa-circle-check"></i>Minimize Breakdowns
                </div>
              </div>

              <div className="our-price-features-heading">
                AC Repairs & Maintenance Service
              </div>
              <div className="our-price-features-list">
                <div>
                  <i class="fa-solid fa-circle-check"></i>High-Quality AC
                  Repairs
                </div>
                <div>
                  <i class="fa-solid fa-circle-check"></i>Experienced AC Service
                  Engineers
                </div>
                <div>
                  <i class="fa-solid fa-circle-check"></i>Manufacturer warranty
                  on spare parts
                </div>
                <div>
                  <i class="fa-solid fa-circle-check"></i>AC AMC (Annual
                  Maintenance) Plans Available
                </div>
                <div>
                  <i class="fa-solid fa-circle-check"></i>30-day warranty on
                  service
                </div>
              </div>

              <div className="our-price-features-text">
                We offer Air Conditioner services in many areas in Delhi NCR.{" "}
                <a href="#coverage">Check Popular Localities & Brands</a>
              </div>
              <div className="our-price-features-text">
                Have questions on your mind? <a href="#faqs">Read The FAQs</a>
              </div>
              <div className="our-price-features-text">
                {/* Our Standard Rate Card. <Link to="/rate-card" target="_blank">View list</Link> */}
              </div>
            </div>

            <div className="our-price-list">
              <div className="our-price-list-heading-1">
                AC Service & Maintenance Plans
              </div>
              <div className="our-price-list-heading-2">
                Select the type of Air Conditioner
              </div>
              <div className="our-price-list-options">
                <div
                  onClick={() => setType("Split")}
                  className={
                    type === "Split" ? "our-price-list-options-active" : ""
                  }
                >
                  Split AC
                </div>
                <div
                  onClick={() => setType("Window")}
                  className={
                    type === "Window" ? "our-price-list-options-active" : ""
                  }
                >
                  Window AC
                </div>
                {/* <div
                  onClick={() => setType("Cassette")}
                  className={
                    type === "Cassette" ? "our-price-list-options-active" : ""
                  }
                >
                  Cassette AC
                </div> */}
              </div>
              <div className="our-price-list-price">
                {OurPriceData &&
                  OurPriceData.filter((e) => e.AC_Type === type).map((e, i) => (
                    <OurPriceServiceCard e={e} i={i} setView={setView} view={view} />
                  ))}
              </div>
            </div>
          </div>

          <div className="cta-button">
            <a href="#book-now">Book Service Now</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurPrice;
